import { Toolbar, ToolbarButton } from '@mui/x-data-grid';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { useMenuControl } from 'hooks/useMenuControl';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import { MouseEventHandler } from 'react';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: theme.spacing(1),

    // button height
    '& .MuiButton-root': {
        height: 36
    }
}));

interface FormsToolbarProps {
    issueFormMenuItems?: {
        label: string;
        onClick?: MouseEventHandler<HTMLLIElement>
    }[]
}

declare module '@mui/x-data-grid' {
    interface ToolbarPropsOverrides extends FormsToolbarProps { }
}

export function FormsToolbar({ issueFormMenuItems }: FormsToolbarProps) {
    const issueFormMenu = useMenuControl();

    return (
        <StyledToolbar>
            {!!issueFormMenuItems && (
                <ToolbarButton
                    render={<Button variant="outlined" />}
                    onClick={issueFormMenu.openMenu}
                >
                    Issue Form
                </ToolbarButton>
            )}
            <Menu {...issueFormMenu.menuProps} onClick={issueFormMenu.closeMenu}>
                {issueFormMenuItems?.map(({ label, onClick }, idx) => (
                    <MenuItem key={idx} onClick={onClick}>{label}</MenuItem>
                ))}
            </Menu>
        </StyledToolbar>
    );
}

export default FormsToolbar;
